import React, { useEffect, useState } from "react";
import EditableSelect from "../../../components/EditableSelect";
import EditableTextView from "../../../components/EditableTextView";
import Constants from "../../../data/Constants";
import Utils from "../../../utils";
import ModuleView from "./ModuleView";
import TopicView from "./TopicView";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import FloatingContainer from "../../../components/FloatingContainer";
import ThemeButton from "../../../components/ThemeButton";
import {
  createSingleCurriculum,
  getSingleCurriculum,
  updateSingleCurriculum,
} from "../../../services/curriculum.service";
import { AiFillDelete } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { MenuItem, TextField } from "@mui/material";

const defaultCurriculum = {
  name: undefined,
  type: undefined,
  modules: [],
};

function Curriculum(props) {
  // try loading from localstorage

  const navigate = useNavigate();

  const cacheCurriculum =
    JSON.parse(localStorage.getItem("draftCurriculum")) ?? defaultCurriculum;
  const { setProgress, setToast } = useOutletContext();

  const [updateView, forceUpdateView] = useState(0);
  const [curriculum, setCurriculum] = useState(cacheCurriculum);
  const [module, setModule] = useState();
  const [topic, setTopic] = useState();

  const { id } = useParams();

  useEffect(() => {
    const api = async () => {
      try {
        setProgress(true);
        const res = await getSingleCurriculum(id);
        if (res) {
          setProgress(false);
          setCurriculum(res);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      } catch (error) {
        // error
        console.log(error);
        setProgress(false);
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    };

    // get currc. data if ID is set
    if (id) {
      api();
    }
  }, [updateView]);

  useEffect(() => {
    if (module) {
      const temp = { ...curriculum };

      temp.modules = temp.modules.map((m) => {
        if (m._id == module._id) {
          if (topic) {
            const tmpTopics = m.topics.map((t) => {
              if (t._id == topic._id) {
                return topic;
              } else {
                return t;
              }
            });
            m.topics = tmpTopics;
          }

          return module;
        } else {
          return m;
        }
      });

      setCurriculum(temp);
    }
  }, [module, topic]);

  useEffect(() => {
    // Sync with Local Storage if create a new one
    if (curriculum && !id) {
      localStorage.setItem("draftCurriculum", JSON.stringify(curriculum));
    }

    // handle Reset of curriculum and update module and topic view
    if (curriculum.modules.length == 0) {
      setModule(undefined);
      setTopic(undefined);
    }
  }, [curriculum]);

  const discardHandler = () => {
    if (id) {
      forceUpdateView(1);
    } else {
      setCurriculum(defaultCurriculum);
    }
  };
  const saveChangesHandler = async () => {
    try {
      // return console.log(curriculum);
      setProgress(true);
      const res = id
        ? await updateSingleCurriculum(id, curriculum)
        : await createSingleCurriculum(curriculum);

      setProgress(false);

      if (id) {
        setToast({
          success: true,
          message: Constants.Actions.Updated.Success("Curriculum"),
        });
      } else {
        setToast({
          success: true,
          message: Constants.Actions.Created.Success("Curriculum"),
        });

        // fix. becoz update curriculum with default is not updating local storage
        localStorage.setItem(
          "draftCurriculum",
          JSON.stringify(defaultCurriculum)
        );
        navigate("/dashboard/curriculum/edit/" + res._id);
      }
    } catch (error) {
      console.log(error);
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  return (
    <div>
      <div className="grid h-full grid-flow-row md:grid-flow-col mb-16 md:mb-0 transition-all">
        <div className="h-full">
          <h1 className="font-extrabold text-lg my-3 text-center">
            Curriculum View
          </h1>

          <div className="m-2">
            <TextField
              label="Curriculum Name"
              variant="filled"
              size="small"
              value={curriculum.name ?? ""}
              onChange={(e) => {
                setCurriculum({ ...curriculum, name: e.target.value });
               
              }}
              required
              fullWidth
            />
          </div>

          <div className="m-2">
            <TextField
              label="Type"
              variant="filled"
              size="small"
              value={curriculum.type ?? Constants.Curriculum.Default}
              onChange={(e) => {
                setCurriculum({
                  ...curriculum,
                  type: e.target.value,
                });
              }}
              // error={
              //   getIn(formik.touched, "courseDetails.curriculum") &&
              //   Boolean(getIn(formik.errors, "courseDetails.curriculum"))
              // }
              // helperText={
              //   getIn(formik.touched, "courseDetails.curriculum") &&
              //   getIn(formik.errors, "courseDetails.curriculum")
              // }
              required
              select
              fullWidth
            >
              {Constants.Curriculum.Types.map((type, index) => {
                return (
                  <MenuItem key={index} value={type}>
                    {type}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>

          <div className="p-2">
            <div className="font-bold">Modules:</div>
            <div className="flex flex-col my-3 gap-3">
              {curriculum.modules.map((mod, index) => {
                if (mod._deleted) {
                  return;
                }

                var style =
                  "p-2 rounded-lg cursor-pointer flex gap-2 items-center";

                if (module) {
                  if (module._id == mod._id) {
                    style += " bg-secondaryDark";
                  } else {
                    style += " bg-secondary  hover:bg-secondaryDark ";
                  }
                } else {
                  style += " bg-secondary  hover:bg-secondaryDark ";
                }

                return (
                  <div
                    key={index}
                    className={style}
                    onClick={() => {
                      setModule(mod);
                      setTopic(undefined);
                    }}
                  >
                    <div className="flex-grow">{mod.name}</div>
                    <div
                      onClick={() => {
                        // delete state bug

                        const temp = { ...curriculum };
                        if (!mod._new) {
                          mod._deleted = true; // soft delete
                        } else {
                          temp.modules.splice(index, 1);
                        }

                        setCurriculum(temp);
                      }}
                    >
                      <MdDelete
                        size={20}
                        className="opacity-80 active:scale-110"
                      />
                    </div>
                  </div>
                );
              })}
              <div
                className=" p-2 rounded-lg bg-primary text-white cursor-pointer text-center font-bold"
                onClick={() => {
                  const mod = {
                    name: "New Module",
                    topics: [],
                    _id: "LOCAL_" + Utils.uniqueId(),
                    _new: true, // imp: it is send to server to notify this is newly created and create this object
                  };
                  const temp = { ...curriculum };
                  temp.modules.push(mod);
                  setTopic(undefined);
                  setModule(mod);
                  setCurriculum(temp);
                }}
              >
                New Module +
              </div>
            </div>
          </div>
        </div>
        {module && (
          <ModuleView
            module={module}
            curriculumHooks={[curriculum, setCurriculum]}
            moduleHooks={[module, setModule]}
            topicHooks={[topic, setTopic]}
          />
        )}

        {topic && (
          <TopicView
            curriculumHooks={[curriculum, setCurriculum]}
            moduleHooks={[module, setModule]}
            topicHooks={[topic, setTopic]}
          />
        )}
      </div>

      <FloatingContainer>
        <ThemeButton variant="text" className="px-4" onClick={discardHandler}>
          Discard
        </ThemeButton>
        <ThemeButton onClick={saveChangesHandler}>Save Changes</ThemeButton>
      </FloatingContainer>
    </div>
  );
}

export default Curriculum;
